import React, { useEffect, useState } from 'react';
import Service from '../../services/news';

const createDOMPurify = require('dompurify');
const DOMPurify = createDOMPurify(window);
const NewsOverview = ({ history }) => {
    const [news, setNews] = useState([]);

    useEffect(() => {
        Service.get().then(result => {
            setNews(result.filter((video) => video.publish));
        });
    }, [])

    const handleViewNieuws = (item) => {
        history.push('/home/' + item._id)
    }

    //  <div style={{ width: '100%' }}  dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.content) }} ></div>
    return <div style={{ display: 'flex', flexWrap: 'wrap' }}>
        {news.map((item, index) => {
            return (
                <div onClick={() => { handleViewNieuws(item) }} key={item._id} style={{ verticalAlign: 'bottom', cursor: 'pointer', backgroundColor: 'white', backgroundImage: `url(${item.image})`, backgroundSize: 'cover', backgroundPosition: 'center center', paddingTop: '300px', width: '300px', margin: '20px' }} className=' radius-right shadow' >

                    <div style={{ height: '100px', background: 'black', background: 'linear-gradient(0deg, rgba(255,255,255,0) 0%, rgba(0,0,0,0.5402135854341737) 30%, rgba(0,0,0,0.5953956582633054) 71%, rgba(255,255,255,0) 100%)', width: '100%' }}>
                        <div style={{ padding: '12px' }}>  <h2 style={{ color: 'white', fontWeight: 'bolder' }}>{item.title}</h2></div>

                    </div>
                    <br style={{ clear: 'both' }} />
                    <svg width="160" height="60" xmlns="http://www.w3.org/2000/svg" style={{ float: 'right' }}>

                        <path id="svg_3" d="m162.52504,61.04251l0,-62.00002l-166.00001,62.00002l166.00001,0z" fill="#ff7f00" />

                    </svg>

                    <br style={{ clear: 'both' }} />

                </div>
            )
        })}
    </div>


};

export default NewsOverview;